<div class="container">
  <mat-card class="card">
    <mat-card-header>
      <mat-card-title>{{ 'ThanksForPlaying' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
    </mat-card-content>
    <mat-card-actions>
      <div class="btn-wrapper">
        <button class="next-button" mat-raised-button color="secondary" (click)="toStart()">{{ 'ToStart' | translate }}</button>
        <button class="next-button" mat-raised-button color="primary" (click)="restart()">{{ 'Restart' | translate }}</button>
      </div>
    </mat-card-actions>
  </mat-card>
</div>